export const pagesPaths = {
  home: '/home',
  homeV2: '/home',
  nominations: '/nominations',
  admin: '/admin',
  managerApproval: '/manager-approval',
  downloadDocuments: '/download-documents',
  proxy: '/proxy',
  evaluations: '/evaluations',
  evaluationsOverview: '/evaluations/overview',
  reports: '/reports',
  roleSetting: '/role-setting',
  idp: '/idp/individual',
  myTeamIdp: '/idp/my-team',
  myTeamAssessmentsCompletion: '/my-team/assessments-completion',
  results: '/results',
  nominationsDashboard: '/nominations-dashboard',
  assessmentsDashboard: '/assessments-dashboard',
  reportsManager: '/reports-manager',
} as const;

export type PagesPathsKeys = keyof typeof pagesPaths;
